import styled from 'styled-components';

export const AnchorStyle = styled.a`
  color: #6200ea;
  text-decoration: underline;
  :hover {
    color: #6200ea;
    text-decoration: underline;
  }
`;

export const StyledTableWrapper = styled.div`
  background: #ffffff;
  padding: 20px;
`;

export const PrimaryStyle = styled.span`
  color: #6200ea;
`;
